// Shared time formatting helpers. The site is operated from US Central Time;
// every admin-facing timestamp on the page should render in CT regardless of
// the viewer's browser locale so logs are consistent across devices.
//
// Storage in MongoDB stays UTC. Conversion is presentation-only.

const CT_TZ = 'America/Chicago';

const safeDate = (input) => {
  if (input === null || input === undefined) return null;
  const d = input instanceof Date ? input : new Date(input);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatCT = (input, options = {}) => {
  const d = safeDate(input);
  if (!d) return '—';
  return d.toLocaleString('en-US', {
    timeZone: CT_TZ,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    ...options,
  });
};

export const formatCTShort = (input) =>
  formatCT(input, { second: undefined });

export const formatCTLabel = (input) => {
  const base = formatCT(input);
  return base === '—' ? base : `${base} CT`;
};

export const CT_TIMEZONE = CT_TZ;
